/**
api接口的统一出口
*/

import example from './example'

export default {
  example
  // xxxx
}
